module.exports = __webpack_public_path__ + "static/media/1.36296854.jpg";